import React, { useState } from 'react';
import { createSalesForm } from '../../../views/sales/salesOrderForm/SalesOrderForm';
import FormModalFormatter, { IFormModalFormatterProps } from './FormModalFormatter';
import getIn from '../../connectedForm/utils/getIn';
import SalesOrder from '../../../graphql/entities/sales/SalesOrder';

//Create a clone of the Sales Order form with a unique type - Note that if we need a 3rd level of nesting for some reason, this is not sufficient.
const ModalSalesOrderForm = createSalesForm({ ...SalesOrder, type: 'SalesOrderFormModalDisplay' });

const SalesOrderFormModalFormatter = ({ value, dependentValues }: IFormModalFormatterProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const idValue = getIn(dependentValues.rowData, dependentValues.options?.entityId);

  return (
    <FormModalFormatter modalOpen={modalOpen} setModalOpen={setModalOpen} value={value}>
      <ModalSalesOrderForm
        forceReadOnly={true}
        onClose={() => setModalOpen(false)}
        pageView={true}
        match={{ params: { id: idValue } }}
        overrideParams={{ id: idValue }}
      />
    </FormModalFormatter>
  );
};

export default SalesOrderFormModalFormatter;
